export const ERROR_REPORTING_PACKAGE = 'jiraPortfolio3PlanDuplicating';
export const ERROR_REPORTING_TEAM = 'advanced-roadmaps';
export const DUPLICATE_ERROR_FLAG_ID = 'duplicatePlanError';
export const MAX_PLAN_NAME_LENGTH = 255;
